module.exports = __webpack_public_path__ + "static/img/ihme-ilmat-puuha.89459f3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ihme-ilmat-puuha.jpeg
// module id = vPTn
// module chunks = 1